module.exports = __webpack_public_path__ + "img/edit_event_step3_on.70e6e452.png";